const getActives = list => list.filter(item => item.active);

export default getActives;
